<p-toast></p-toast>
<div class="main">
 
    <div class="back">
        <img src="../../../assets/icons/back.svg" class="back-icon" />
        <p (click)="goHome()">Back to home</p>
    </div>
    <div class="header">
        <p class="title">All Files</p>
            <div class="right">
                <div class="grid">
                    <div class="col-4" (click)="archive_multiple_files()"  *ngIf="files?.length>=1">
                            <div class="btn btn-primary" >
                                Delete File(s)
                            </div>
                    </div>
                    <div class="col-8">
                        <input type="search" class="search" placeholder="search for files" #searchInput
                        (input)="search(searchInput.value)" />  
                    </div>
                </div>
            </div>
        
    </div>
   
    <ng-container *ngIf="is_empty();else table_div">
        <div class="text-center mx-auto green">
            No files
        </div>

    </ng-container>
    <ng-template #table_div>
        <p-table [value]="files" #all_files selectionMode="multiple" [rows]="rows" [(selection)]="archive_ids" dataKey="_id" responsiveLayout="scroll"
        [scrollable]="true"  
        scrollHeight="60vh">
            <ng-template pTemplate="header">
                <tr class="p-0">
                    <th class="text-center">
                        <p-tableHeaderCheckbox (click)="selectRow(e.checked)" #e></p-tableHeaderCheckbox>
                    </th>
                    <th class="pl-1"></th>
                    <th class="pl-1" [pSortableColumn]="'event_details.name'">Event Name<p-sortIcon
                            field=""></p-sortIcon></th>
                    <th class="pl-1" [pSortableColumn]="'event_details.time'">Created On<p-sortIcon
                            field=""></p-sortIcon></th>
                    <th class="pl-1" [pSortableColumn]="'created_by'">Processed by<p-sortIcon field=""></p-sortIcon>
                    </th>
                    <th class="pl-1" [pSortableColumn]="'event_details.location'">Location<p-sortIcon
                            field=""></p-sortIcon></th>
                    <th class="pl-1">Processed Languages</th>
                    <th class="pl-1"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-file>
                <tr class="p-3" [id]="file?._id">
                    <td class="text-center">
                        <p-tableCheckbox [value]="file" [disabled]="file_created_by_admin_demo(file)"></p-tableCheckbox>
                    </td>
                    <td class="text-center">
                        <app-audio-player [url]="get_cdn_url(file?.input_file?.path)"></app-audio-player>
                    </td>
                    <td>{{ get_title_case(file?.event_details?.name) }}</td>
                    <td>{{ file?.event_details?.time }}</td>
                    <td>
                        {{ get_title_case(file?.created_by) }}
                    </td>
                    <td>{{ get_title_case(file?.event_details?.location) }}</td>
                    <td>
                        <ng-container *ngIf="get_each_language(file?.outputs?.translation).languages==''; else language_names">
                            <div class="green "> No Languages Processed
                            </div>
                        </ng-container>
                        <ng-template #language_names>
                            <div *ngFor="let language_object of [get_each_language(file?.outputs?.translation)]" >
                                <p>{{ language_object?.languages }} 
                                    <span
                                        *ngIf="language_object?.remaining_length!=null && language_object?.remaining_length!=undefined && language_object.remaining_length>0"
                                        [title]="language_object?.remaining_languages" class="green">
                                        ,+
                                        {{language_object?.remaining_length}}
                                    </span>
                                </p>
                            </div>
                        </ng-template>
                    </td>
                    <td>
                    <button class="btn btn-dark" (click)="viewOutput(file)">View Output</button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
            <ng-container *ngIf="archive_ids && archive_ids.length!=0; else files_length">
                Selected {{ archive_ids.length }} out of {{ files.length }}
            </ng-container>
            <ng-template #files_length>
                Total files: {{ files.length }}
            </ng-template>
            </ng-template>
        </p-table>
    </ng-template>


</div>
<!--  <div class="cards grid">
     <app-card class="col" [file]="file" *ngFor="let file of files"></app-card> 
        </div> -->